import React from 'react';
import Header from './Components/Main/Header.js'

function App() {
  return <Header />;
}

export default App;
